import * as React from 'react';
import { mapListingProductRecordToListingProduct } from '@grandvisionhq/fun-search';
import { mapProductProjectionToListingProduct } from '@grandvisionhq/products';
import { useIntl, useFeatureToggles } from '@grandvisionhq/state';

const isProductProjection = (data)=>'masterVariant' in data && 'slug' in data
;
const isListingProductRecord = (data)=>'sku' in data && 'variants' in data
;
function useAlgoliaIndex(searchResults = [], productType = '', priceSegmentCookie) {
    const intl = useIntl();
    const { featureConfigs: { algoliaIndexV2EnabledProductTypes  } ,  } = useFeatureToggles();
    const mappedResults = React.useMemo(()=>{
        {
            if (productType && (algoliaIndexV2EnabledProductTypes === null || algoliaIndexV2EnabledProductTypes === void 0 ? void 0 : algoliaIndexV2EnabledProductTypes.includes(productType.toLowerCase()))) {
                return searchResults.map((hit)=>isListingProductRecord(hit) ? mapListingProductRecordToListingProduct(hit, intl, priceSegmentCookie) : undefined
                );
            } else {
                return searchResults.map((hit)=>isProductProjection(hit) ? mapProductProjectionToListingProduct(hit, intl, priceSegmentCookie) : undefined
                );
            }
        }
    }, [
        searchResults,
        intl,
        algoliaIndexV2EnabledProductTypes,
        productType,
        priceSegmentCookie
    ]);
    return mappedResults;
}

export { useAlgoliaIndex };
//# sourceMappingURL=use-algolia-index.js.map
